import { Division, Region } from "src/app/core/services/ebr-api-client/ebr-api-client.g";
import {FilterValue} from "./base";
import { PresentationType } from "src/app/core/types/presentation-types";


export const REGIONS: FilterValue[] = [
  {name: 'Asia Pacific', code: Region.AP},
  {name: 'Europe', code: Region.EU},
  {name: 'India, Middle East, Africa', code: Region.IMEA},
  {name: 'Latin America', code: Region.LA},
  {name: 'North America', code: Region.NA},
];

export const PERIODS: FilterValue[] = [
  {name: 'Last Month', code: 'Prior Month'},
  {name: 'Last 3 Months', code: 'R3'},
  {name: 'Last 6 Months', code: 'R6'},
  {name: 'Last 12 Months', code: 'R12'},
  {name: 'Last 24 Months', code: 'R24'},
  {name: 'Year To Date', code: 'YTD'},
  {name: 'Custom', code:'Custom'}
];

// Common templates across LA, IMEA, EU and AP
export const TEMPLATES: FilterValue[] = [
  {name: 'Lodging', regionLabel: 'Lodging', code:PresentationType.Lodging},
  {name: 'Food Service', regionLabel: 'Food Service', code:PresentationType.FoodService},
  {name: 'Facilities', regionLabel: 'Facilities', code:PresentationType.Facilities},
  {name: 'Education', regionLabel: 'Education', code:PresentationType.Education},
  {name: 'Long Term Care', regionLabel: 'Long Term Care', code:PresentationType.LongTermCare},
  {name: 'SMARTPOWER', regionLabel: 'SMARTPOWER', code:PresentationType.SMARTPOWER},
  {name: 'Other', regionLabel: 'Other', code:PresentationType.Other},
];

export const TEMPLATES_EU: FilterValue[] = [
  {name: 'TVD', regionLabel: 'TVD EU', code: PresentationType.TvdEU},
  ...TEMPLATES
];

export const TEMPLATES_NA : FilterValue[] = [
  {name: 'All', regionLabel: 'TVD NA', code: PresentationType.TvdNA}
];

export const TEMPLATES_AP : FilterValue[] = [
  {name: 'All', regionLabel: 'All AP', code: PresentationType.AllAP},
  ...TEMPLATES
];

export function getTemplatesAP(isFeatureEnabled: boolean): FilterValue[] {
  return isFeatureEnabled
    ?  [{ name: 'All', regionLabel: 'TVD AP', code: PresentationType.TvdAP }]
    : TEMPLATES_AP;
}


export function getTemplatesLA(isFeatureEnabled: boolean): FilterValue[] {
  if (!isFeatureEnabled) return TEMPLATES;
  return [{ name: 'All', regionLabel: 'TVD LA', code: PresentationType.TvdLA }];
}

export function getTemplatesIMEA(isFeatureEnabled: boolean): FilterValue[] {
  if (!isFeatureEnabled) return TEMPLATES;
  return [{ name: 'All', regionLabel: 'TVD IMEA', code: PresentationType.TvdIMEA }];
}

export const TEMPLATE_TRANSLATIONS: FilterValue[] = [
  {name: 'Arabic', code: 'arabic'},
  {name: 'English', code: 'english'},
  {name: 'French (EU)', code: 'french-eu'},
  {name: 'German', code: 'german'},
  {name: 'Korean', code: 'korean'},
  {name: 'Italian', code: 'italian'},
  {name: 'Japanese', code: 'japanese'},
  {name: 'Portuguese (Brazil)', code: 'portuguese-brazil'},
  {name: 'Spanish (EU)', code: 'spanish-eu'},
  {name: 'Spanish (LA)', code: 'spanish-la'},
  {name: 'Turkish', code: 'turkish'}
];

export const TEMPLATE_TRANSLATIONS_NATIVE_FORM: {englishName: string, code:string, nativeName:string}[] = [
  {englishName: 'Arabic', code: 'arabic', nativeName: 'العربية'}, //عربي
  {englishName: 'English', code: 'english', nativeName: 'English'},
  {englishName: 'French (EU)', code: 'french-eu', nativeName: 'Français'},
  {englishName: 'German', code: 'german', nativeName: 'Deutsch'},
  {englishName: 'Korean', code: 'korean', nativeName: '한국어'},
  {englishName: 'Italian', code: 'italian', nativeName: 'Italiano'},
  {englishName: 'Japanese', code: 'japanese', nativeName: '日本語'},
  {englishName: 'Portuguese (Brazil)', code: 'portuguese-brazil', nativeName: 'Português Brasileiro'},
  {englishName: 'Spanish (EU)', code: 'spanish-eu', nativeName: 'Español (UE)'},
  {englishName: 'Spanish (LA)', code: 'spanish-la', nativeName: 'Español (LA)'},
  {englishName: 'Turkish', code: 'turkish', nativeName: 'Türkçe'}
];


export enum FilterType {
  REGION,
  PERIOD,
  TEMPLATE,
  TEMPLATES_AP,
  TEMPLATE_TRANSLATION,
  TEMPLATES_NA,
  TEMPLATES_EU
}

export type TranslationOption = {
  name: string;
  code: string;
};

export type PresentationConfig = {
  presentationType: PresentationType;
  displayName: string;
};

export type PresentationConfigMap = Record<
  Division,
  Partial<Record<Region, Array<PresentationConfig>>>
>;

export function updatePresentationConfigurationOptionsForAPInstitutional(featureFlagEnabled : boolean){
  if(featureFlagEnabled){
    PresentationConfiguration[Division.Institutional][Region.AP] = [
      { presentationType: PresentationType.TvdAP, displayName: 'TVD AP' }
    ];
  }
  else{
    PresentationConfiguration[Division.Institutional][Region.AP] = [
      { presentationType: PresentationType.AllAP, displayName: 'All AP' },
      { presentationType: PresentationType.Lodging, displayName: 'Lodging' },
      { presentationType: PresentationType.FoodService, displayName: 'Food Service' },
      { presentationType: PresentationType.Facilities, displayName: 'Facilities' },
      { presentationType: PresentationType.Education, displayName: 'Education' },
      { presentationType: PresentationType.LongTermCare, displayName: 'Long Term Care' },
      { presentationType: PresentationType.SMARTPOWER, displayName: 'SMARTPOWER' },
      { presentationType: PresentationType.Other, displayName: 'Other' },
    ];
  }
};

export function updatePresentationConfigurationOptionsForLAInstitutional(featureFlagEnabled : boolean){
  if(featureFlagEnabled){
    PresentationConfiguration[Division.Institutional][Region.LA] = [
      { presentationType: PresentationType.TvdLA, displayName: 'TVD LA' },
    ];
  }
  else{
    PresentationConfiguration[Division.Institutional][Region.LA] = [
      { presentationType: PresentationType.Lodging, displayName: 'Lodging' },
      { presentationType: PresentationType.FoodService, displayName: 'Food Service' },
      { presentationType: PresentationType.Facilities, displayName: 'Facilities' },
      { presentationType: PresentationType.Education, displayName: 'Education' },
      { presentationType: PresentationType.LongTermCare, displayName: 'Long Term Care' },
      { presentationType: PresentationType.SMARTPOWER, displayName: 'SMARTPOWER' },
      { presentationType: PresentationType.Other, displayName: 'Other' },
    ];
  }
};

 /**
   * 
   * @returns An array of available presentation types for the selected division and regions.
   */
  export function getAvailablePresentationTypes(division : Division, regions: Region[]): PresentationConfig[] {

    if (!division || !regions?.length) {
      return [];
    }

    const divisionConfig = PresentationConfiguration[division];

    const presentationConfigs = regions.flatMap(region => divisionConfig?.[region] ?? []);

    return Array.from(
      new Map(
        presentationConfigs.map(config => [config.presentationType, config])
      ).values()
    );
  }

  /**
   * Returns the PresentationConfiguration object filtered by the selected division and regions.
   */
  export function getAvailablePresentationConfig(division : Division, regions: Region[]): Record<Region, PresentationConfig[]> {

    if (!division || !regions?.length) {
      return Object.values(Region).reduce((config, region) => {
        config[region] = [];
        return config;
      }, {} as Record<Region, PresentationConfig[]>);
    }

    const divisionConfig = PresentationConfiguration[division];

    return Object.values(Region).reduce((config, region) => {
      config[region] = regions.includes(region)
        ? divisionConfig?.[region] ?? []
        : [];
      return config;
    }, {} as Record<Region, PresentationConfig[]>);
  }

//todo : move this to app config
export var PresentationConfiguration: PresentationConfigMap = {
  [Division.Institutional]: {
    [Region.NA]: [
      {presentationType: PresentationType.TvdNA, displayName: 'TVD NA'},
    ],
    [Region.EU]:[
      {presentationType: PresentationType.TvdEU, displayName: 'TVD EU'},
      {presentationType: PresentationType.Lodging, displayName: 'Lodging'},
      {presentationType: PresentationType.FoodService, displayName: 'Food Service'},
      {presentationType: PresentationType.Facilities, displayName: 'Facilities'},
      {presentationType: PresentationType.Education, displayName: 'Education'},
      {presentationType: PresentationType.LongTermCare, displayName: 'Long Term Care'},
      {presentationType: PresentationType.SMARTPOWER, displayName: 'SMARTPOWER'},
      {presentationType: PresentationType.Other, displayName: 'Other'},     
    ],
    [Region.AP]:[
      //When feature flag is enabled
      {presentationType: PresentationType.TvdAP, displayName: 'Asia Pacific Standard'},
      //When feature flag is disabled
      {
       presentationType: PresentationType.AllAP, displayName: 'All AP'
      },
      {presentationType: PresentationType.Lodging, displayName: 'Lodging'},
      {presentationType: PresentationType.FoodService, displayName: 'Food Service'},
      {presentationType: PresentationType.Facilities, displayName: 'Facilities'},
      {presentationType: PresentationType.Education, displayName: 'Education'},
      {presentationType: PresentationType.LongTermCare, displayName: 'Long Term Care'},
      {presentationType: PresentationType.SMARTPOWER, displayName: 'SMARTPOWER'},
      {presentationType: PresentationType.Other, displayName: 'Other'},
    ],
    [Region.LA]:[
      {presentationType: PresentationType.TvdLA, displayName: 'Latin America Standard'},
      {presentationType: PresentationType.Lodging, displayName: 'Lodging'},
      {presentationType: PresentationType.FoodService, displayName: 'Food Service'},
      {presentationType: PresentationType.Facilities, displayName: 'Facilities'},
      {presentationType: PresentationType.Education, displayName: 'Education'},
      {presentationType: PresentationType.LongTermCare, displayName: 'Long Term Care'},
      {presentationType: PresentationType.SMARTPOWER, displayName: 'SMARTPOWER'},
      {presentationType: PresentationType.Other, displayName: 'Other'},
    ],
    [Region.IMEA]:[
      {presentationType: PresentationType.TvdIMEA, displayName: 'India, Middle East, Africa Standard'},
      {presentationType: PresentationType.Lodging, displayName: 'Lodging'},
      {presentationType: PresentationType.FoodService, displayName: 'Food Service'},
      {presentationType: PresentationType.Facilities, displayName: 'Facilities'},
      {presentationType: PresentationType.Education, displayName: 'Education'},
      {presentationType: PresentationType.LongTermCare, displayName: 'Long Term Care'},
      {presentationType: PresentationType.SMARTPOWER, displayName: 'SMARTPOWER'},
      {presentationType: PresentationType.Other, displayName: 'Other'},
    ]
  },
  [Division.QSR]: {
    [Region.NA]: [{ presentationType: PresentationType.QSR, displayName: 'TVD' }],
    [Region.EU]: [{ presentationType: PresentationType.QSR, displayName: 'TVD' }],
    [Region.AP]: [{ presentationType: PresentationType.QSR, displayName: 'TVD' }],
  },
  [Division.FRS]: {
    [Region.NA]: [{ presentationType: PresentationType.FRS, displayName: 'TVD' }],
    [Region.EU]: [{ presentationType: PresentationType.FRS, displayName: 'TVD' }],
    [Region.AP]: [{ presentationType: PresentationType.FRS, displayName: 'TVD' }],
    [Region.LA]: [{ presentationType: PresentationType.FRS, displayName: 'TVD' }],
  },
  [Division.Pest]: {
    [Region.NA]: [{ presentationType: PresentationType.PestTVD, displayName: 'TVD' }],
  },
  [Division.Distributor]: {
    [Region.NA]: [{ presentationType: PresentationType.Distributor, displayName: 'TVD' }],
  }

}

